module.exports = __webpack_public_path__ + "static/media/math_arena_case_study_screen_3.791cb7d3.png";